import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';

export const getPageTitle = (
    code: string,
    status: ChangeRequestStatus,
): string => {
    return status === ChangeRequestStatus.WAITING_REVIEW
        ? `${code} - Event Review`
        : `${code} - Change Request`;
};
